import React, { createContext, useContext } from "react";

import type { IsMetaProviderProps } from "./types";

const IsMetaContext = createContext<boolean>(false);

export const IsMetaProvider: React.FC<IsMetaProviderProps> = ({
  children,
  isMeta,
}) => {
  return (
    <IsMetaContext.Provider value={Boolean(isMeta)}>
      {children}
    </IsMetaContext.Provider>
  );
};

export const useIsMeta = (): boolean => {
  return useContext(IsMetaContext);
};
